import { Paginado } from '../../../models/paginado.type'

export interface Usuario {
  idUsuario?: string
  nombre: string
  apellidoPaterno: string
  apellidoMaterno?: string
  /** Clave de perfil/rol (catalogo). */
  perfil: string
  /** Clave de posicion (catalogo). */
  posicion: string
  correo?: string
  nivel?: string
  idContacto?: string
  /** Se permite `null`/`undefined` por compatibilidad con formularios que inicializan vacio. */
  telefono: string | null | undefined
  /** Descripciones resueltas para mostrar en UI (no siempre se envian al backend). */
  descPosicion: string
  descPerfil: string
  /** Divisiones de negocio asociadas; determinan alcance de sitios. */
  divisionesNegocio: DivisionDeNegocioOpcion[]
  sitios?: string[]
  estatus?: boolean
  fechaCreacion?: string
  fechaActualizacion?: string
  /** Indica si el usuario esta marcado como ausente en procesos operativos. */
  ausente?: boolean
}

/** Respuesta paginada del endpoint GET de usuarios. */
export interface PaginadoUsuarios extends Paginado {
  usuarios: Usuario[]
}

export interface DivisionDeNegocioOpcion {
  nombre: string
  descripcion: string
}

/** Grupo de sitios por division de negocio (para seleccion en el modal de usuario). */
export interface DivisionDeNegocio {
  divisionDeNegocio: string
  descDivisionDeNegocio: string
  sitios: SitiosDivNegocio[]
}

/** Sitio dentro de una division de negocio, con flag `esSeleccionada` para UI. */
export interface SitiosDivNegocio {
  idSitio: string
  nombre: string
  descRazonSocial: string
  rfc: string
  esSeleccionada?: boolean
}

export const style = {
  borderRadius: '10px',
  background: '#333',
  color: '#fff',
  fontSize: '18px',
}
